import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../../../../base-components/orbit-component/orbit-component';
import {Button} from '../../../../../basic-ui-components/button/base/button.component';
import {CyClass} from '../../../../../../common/cy-classes';

export interface PlayDemoButtonComponentProps {
  enabled: boolean;
  onOpenAnonymousGame: () => void;
}

@observer
export class PlayDemoButtonComponent extends OrbitComponent<PlayDemoButtonComponentProps> {

  render() {
    if(!this.props.enabled) {
      return null;
    }

    return (
      <Button
        className={CyClass('cy-play-demo-game-button')}
        onClick={this.props.onOpenAnonymousGame}
        preset="flatStroked"
      >
        { this.services.translation.translate('DEMO') }
      </Button>
    );

  }
}

